/**
 * Copyright (C) 2026 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import Badge from '@mui/material/Badge';
import appTheme from '../../theme/appTheme.json';

export interface NotificationBadgeProps {
  showBadge: boolean;
  children: React.ReactNode;
}

// Shared notification dot wrapper used by header/menu icons.
const NotificationBadge: React.FC<NotificationBadgeProps> = ({ showBadge, children }) => {
  return (
    <Badge
      variant="dot"
      overlap="circular"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      invisible={!showBadge}
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: appTheme.buttonSelectedColor,
          width: 8,
          height: 8,
          minWidth: 8,
          borderRadius: '50%',
          boxShadow: `0 0 0 1px ${appTheme.mptPrimaryBackgroundColor}`,
        },
      }}
    >
      {children}
    </Badge>
  );
};

export default NotificationBadge;
